import Observable from '@speechki-frontend/shared/Observable';

export default new Observable();
